import { render, staticRenderFns } from "./TranslateWithGoogleButton.vue?vue&type=template&id=0d8ddd95&"
import script from "./TranslateWithGoogleButton.vue?vue&type=script&lang=js&"
export * from "./TranslateWithGoogleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports